import { AvailableOffers } from "../../types/rtk/availableOffers/availableOffers";
import { apiSlice } from "../_api/api-slice";

const availableOffersEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAvailableOffers: build.query<AvailableOffers, void>({
      query: () => ({
        url: `/tracker/available-offers`,
        method: "get",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAvailableOffersQuery,
  useLazyGetAvailableOffersQuery
} = availableOffersEndpoint;